import { Component, computed, inject } from '@angular/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { AuthService, AuthState } from '../../services/auth.service';

@Component({
	selector: 'vis-splash',
	imports: [LoadingSpinnerComponent],
	templateUrl: './splash.component.html',
	styleUrls: ['./splash.component.scss'],
})
export class SplashComponent {
	private auth = inject(AuthService);

	public loadingMessage = computed(() => {
		if (this.auth.state() === AuthState.SigningIn) {
			return 'Signing in...';
		}
		if (this.auth.accountInfoIsLoading()) {
			return 'Loading account information...';
		}
		if (this.auth.accountInfoError()) {
			return 'Error loading account information.';
		}
		return 'Preparing application...';
	});
}
